module.exports = __webpack_public_path__ + "img/X.1f158ee9.svg";